const HTML_ESCAPE_PATTERNS = [
  { escaped: "&lt;li&gt;", unescaped: "<li>" },
  { escaped: "&lt;/li&gt;", unescaped: "</li>" },
  { escaped: "&lt;ul&gt;", unescaped: "<ul>" },
  { escaped: "&lt;/ul&gt;", unescaped: "</ul>" },
  { escaped: "&lt;ol&gt;", unescaped: "<ol>" },
  { escaped: "&lt;/ol&gt;", unescaped: "</ol>" },
  { escaped: "&quot;", unescaped: '"' }
];
export {
  HTML_ESCAPE_PATTERNS
};
